import React, { useState } from 'react';
import { PageTitle, useFeatures } from '@cordata/buffet';
import classnames from 'classnames';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import General from '~/components/Provider/GeneralForm';

const ProvidersAdd = () => {
  const [tab, setTab] = useState(0);
  const { hasAppKickstarter } = useFeatures();

  const tabs = [{
    name: 'General',
    form: General,
    isActive: true,
  }, {
    name: 'Kickstarter',
    isActive: hasAppKickstarter,
  }];

  return (<>
    <PageTitle>Add Provider</PageTitle>

    <Nav tabs>
      {tabs.filter(t => t.isActive).map((t, i) => (
        <NavItem key={`{${t.name}-${t.name}`}>
          <NavLink
            className={classnames({ active: tab === i })}
            onClick={() => { setTab(i); }}
            style={{ cursor: 'pointer' }}
            disabled={i !== 0}
          >
            {t.name}
          </NavLink>
        </NavItem>
      ))}
    </Nav>

    <TabContent activeTab={tab}>
      {tabs.filter(t => t.isActive).map((t, i) => (
        <TabPane tabId={i} key={t.name}>
          {t.form ? (<t.form />) : (<div />)}
        </TabPane>
      ))}
    </TabContent>
  </>);
};

export default ProvidersAdd;
